import type {
	IssueErrorAttributes,
	IssueError,
} from '@atlassian/jira-issue-shared-types/src/common/types/error-type.tsx';

export type Props = {
	errorType: IssueError;
	errorAttributes?: IssueErrorAttributes;
	loginRedirectUrl?: string;
};

export const SUCCESS_TRACKER_TESTID =
	'issue.views.issue-details.error.ui.issue-error-view-with-success-tracking.view-experience-success-tracker';

export const FAILURE_TRACKER_TESTID =
	'issue.views.issue-details.error.ui.issue-error-view-with-success-tracking.view-experience-failure-tracker';

export const ABORT_TRACKER_TESTID =
	'issue.views.issue-details.error.ui.issue-error-view-with-success-tracking.view-experience-abort-tracker';
